// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body #app .loader-wrapper .loader[data-v-8a896d8a]{width:unset}body #app .loader-wrapper .loader img[data-v-8a896d8a]{max-width:100%}", ""]);
// Exports
module.exports = exports;
